/**
 * Created by Gaplo917 on 10/7/2017.
 */
import * as PIXI from "pixi.js";

// just extends for a better class name
export default class Scene extends PIXI.Container {
  constructor(){
    super()
  }
}


// WEBPACK FOOTER //
// ./src/game/objects/Scene.js